var $a6f6bc6453c21fdb$exports = {};
$a6f6bc6453c21fdb$exports = {
    "endTime": `Ora di fine`,
    "startTime": `Ora di inizio`,
    "time": `Ora`
};


export {$a6f6bc6453c21fdb$exports as default};
//# sourceMappingURL=it-IT.mjs.map
